import {createSlice} from '@reduxjs/toolkit';
import {PackageDetailsDto} from 'src/shared/services/package/dto/package-details-dto';

interface PackagesInitialState {
  packagesList: Array<PackageDetailsDto> | undefined;
  packageDetails: PackageDetailsDto | undefined;
  isPackagesListLoading: boolean | undefined;
}

const initialState: PackagesInitialState = {
  packagesList: [],
  packageDetails: undefined,
  isPackagesListLoading: false,
};

const packagesSlice = createSlice({
  name: 'packages',
  initialState: initialState,
  reducers: {
    setPackagesList: (state, action) => {
      state.packagesList = action.payload;
    },
    setpackageDetails: (state, action) => {
      state.packageDetails = action.payload;
    },
    setIsPackagesListLoading: (state, action) => {
      state.isPackagesListLoading = action.payload;
    },
  },
});

export const {setPackagesList, setpackageDetails, setIsPackagesListLoading} =
  packagesSlice.actions;

export default packagesSlice.reducer;
